import React from 'react';
import { colors, zIndex } from '@/assets/styles';
import { Card } from '@/components/ui/cards/Card';
import { IconScout } from '@/components/ui/images/IconScout';
import { PrimaryButton } from '@/components/ui/buttons';
import { Text } from '@/components/ui/text';
import { useTranslation } from '@/i18n';


interface HelpDropdownProps {
  onClose: () => void;
}

interface HelpDropdownButtonProps {
  onClick: () => void;
  icon: React.ReactNode;
  children: React.ReactNode;
}

const HelpDropdownButton: React.FC<HelpDropdownButtonProps> = ({ 
  onClick, 
  icon, 
  children,
}) => (
  <PrimaryButton
    onClick={onClick}
    variant="ghost"
    size="sm"
    textAlign="left"
    className="py-2 px-2 rounded-md justify-between [&>div]:w-full"
    iconRight={icon}
    iconSize={16}
    customVariant={{
      default: {
        textColor: colors.grays.neutral33,
      },
      pressed: {
        textColor: colors.grays.neutral33,
      },
      focus: {
        textColor: colors.grays.neutral33,
      },
    }}
    textVariant="small-regular"
    fullWidth
  >
    {children}
  </PrimaryButton>
);

const HelpDropdown: React.FC<HelpDropdownProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const handleHelpCenterClick = () => {
    onClose();
    window.open('https://ayudabnovus.rexmas.com/es/', '_blank', 'noopener,noreferrer');
  };

  const handleDTClick = () => {
    onClose();
    window.open('https://dt.gob.cl/legislacion/1624/w3-article-127750.html', '_blank', 'noopener,noreferrer');
  };

  return (
    <Card
      padding="16px 8px 16px 16px"
      className="tooltip-system-options absolute right-0 mt-2 w-[172px]"
      style={{ visibility: 'visible', zIndex: zIndex.menuDropdown }}
    >
      <div className="mb-3 px-2 text-left">
        <Text variant="subheader-medium" color={colors.primary.dash}>
          {t('common:navigation.supportAndCertificate')}
        </Text>
      </div>
      <div className="item-option mb-1">
        <HelpDropdownButton
          onClick={handleHelpCenterClick}
          icon={<IconScout name="externalLink" size="md" color={colors.primary.main} />}
        >
          {t('common:navigation.helpCenter')}
        </HelpDropdownButton>
      </div>
      <div className="item-option">
        <HelpDropdownButton
          onClick={handleDTClick}
          icon={<IconScout name="externalLink" size="md" color={colors.primary.main} />}
        >
          Certificado DT
        </HelpDropdownButton>
      </div>
    </Card>
  );
};

export default HelpDropdown;
